import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-running-surface" data-id="element-64">
      <div className="max-w-3xl mx-auto text-center" data-id="element-65">
        <FadeIn data-id="element-66">
          <ShieldCheckIcon className="w-16 h-16 text-running-blue mx-auto mb-6" data-id="element-67" />
          <h2 className="text-3xl font-display font-bold text-white mb-6" data-id="element-68">
            La garantía es simple porque el producto es serio.
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed mb-6" data-id="element-69">
            Abrís los módulos. Los aplicás con tus alumnos. Si en 7 días no es
            exactamente lo que esperabas, te devolvemos el 100% del dinero. Sin
            formularios. Sin preguntas. Sin drama.
          </p>
          <div className="inline-block bg-running-dark border border-running-muted px-6 py-3 rounded-lg" data-id="element-70">
            <p className="text-running-blue font-bold" data-id="element-71">
              La tasa de devolución es menor al 1%.
            </p>
            <p className="text-sm text-gray-400 mt-1" data-id="element-72">
              No porque tengamos una política difícil. Sino porque el sistema
              funciona.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}